import { cond, gt, always, T } from 'ramda'

import styles from './SubsidyIndicator.module.scss';

type Props = {
  available: number
  used: number
}

const SubsidyIndicator = ({ available, used }: Props) => {
  const perPercent = available ? used / available : used ? 1 : 0 // eslint-disable-line no-nested-ternary
  const color = cond([
    [gt(0.333), always('red')],
    [gt(0.666), always('gold')],
    [T, always('limegreen')],
  ])(perPercent)

  const indicatorStyle = {
    width: `${perPercent * 100}%`,
    height: '4px',
  }

  return (
    <div className={styles.root}>
      <div style={indicatorStyle} />
    </div>
  )
}

export default SubsidyIndicator
